import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { OpenZitiConsoleLibModule } from 'ziti-console-lib';
import { DurationInputComponent } from './duration-input.component';
import { OfflineLadderFieldsComponent } from './offline-ladder-fields.component';
import { OfflinePolicyFormComponent } from './offline-policy-form.component';

/* The same imports as the latency policy form: `lib-loading-indicator` from OpenZitiConsoleLibModule and the
 * component picker from PrimeNG. The ladder fields and the duration input are exported for the listing and the alert dialog. */
@NgModule({
    imports: [CommonModule, FormsModule, MatTooltipModule, AutoCompleteModule, OpenZitiConsoleLibModule],
    declarations: [OfflinePolicyFormComponent, OfflineLadderFieldsComponent, DurationInputComponent],
    exports: [OfflinePolicyFormComponent, OfflineLadderFieldsComponent, DurationInputComponent],
})
export class FeatureFormOfflinePolicyFormModule {}
